export default __webpack_public_path__ + "static/media/headphones.311d8589.png";